export default "assets/images/logo-canei-aa4231ec.svg";